module.exports = __webpack_public_path__ + "static/media/chonky_bday.c9439b8e.MP4";